import { getDeliveryMethodTitle, getDeliveryMethodType } from "@customer-app/utils/getDeliveryMethodTitle";
import { ISmartrrFulfillmentStatus, ISmartrrOrderFromDb } from "@smartrr/shared/entities/Order";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { CardBodySection } from "../../../components";
import { Link, Stack, Typography } from "@mui/material";
import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import React from "react";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { renderCarrierLink } from "../../../utils";
import { useOrganization } from "@customer-app/account/views/OperationAquarius/utils";
import { useSmartrrTheme } from "@customer-app/account/views/OperationAquarius/hooks/useSmartrrTheme";
import { DeliveryMethodType } from "@smartrr/shared/shopifyGraphQL/api";
import { copyToClipboard } from "@smartrr/shared/utils/copyToClipboard";
import { toast } from "react-toastify";
import { OrderHistoryShippedTo } from "../OrderHistoryShippedTo";
import { OrderHistoryShippingMethod } from "../OrderHistoryShippingMethod";

export const RenderItemDetails = ({
  subscription,
  index,
  order,
}: {
  index: number;
  subscription?: IPurchaseState;
  order: ISmartrrOrderFromDb;
}) => {
  const organization = useOrganization();
  const theme = useSmartrrTheme();
  const { trackingInfo, deliveryAddress } = order;
  const deliveryMethod = subscription?.deliveryMethod;
  const deliveryMethodTitle = getDeliveryMethodTitle(deliveryMethod, trackingInfo[0]?.trackingCompany);
  const deliveryMethodType = getDeliveryMethodType(deliveryMethod);

  return (
    <CardBodySection borderColor={theme.modernLineDividers}>
      {order.fulfillmentStatus === ISmartrrFulfillmentStatus.FULFILLED ||
      order.fulfillmentStatus === ISmartrrFulfillmentStatus.PARTIALLY_SHIPPED ? (
        <React.Fragment>
          {trackingInfo?.[0] ? (
            <Stack spacing={1.5} className={prefixClassName("track-shipment")}>
              {deliveryMethodType === DeliveryMethodType.Shipping ? (
                <AquariusButton
                  sx={{ marginTop: "0 !important" }}
                  className={prefixClassName("track-shipment-button")}
                >
                  <Link
                    href={trackingInfo[0]?.trackingUrls?.[0]}
                    underline="none"
                    target="_blank"
                    sx={{ color: "#2E2E2E" }}
                  >
                    {typedLocalize("orderHistory.trackShipment", {
                      firstValue: index + 1,
                      secondValue: trackingInfo.length,
                    })}
                  </Link>
                </AquariusButton>
              ) : null}
              <Stack
                direction="row"
                justifyContent="flex-end"
                className={prefixClassName("contact-carrier-wrapper")}
              >
                <Link
                  href={renderCarrierLink(
                    organization.shopifyStoreData?.customer_email,
                    trackingInfo[0]?.trackingCompany
                  )}
                  className={prefixClassName("contact-carrier")}
                  variant="caption1"
                  underline="always"
                  target="_blank"
                  sx={{
                    opacity: "70%",
                    cursor: "pointer",
                    "&:hover": {
                      opacity: "60%",
                    },
                  }}
                >
                  {typedLocalize("orderHistory.contactCarrier")}
                </Link>
              </Stack>
              {deliveryMethodType === DeliveryMethodType.Shipping ? (
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2" whiteSpace="nowrap">
                    {typedLocalize("orderHistory.tracking")}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: "right",
                      cursor: "pointer",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {trackingInfo[0].trackingNumbers?.map(n => (
                      <span
                        key={n}
                        onClick={() => copyToClipboard(n, typedLocalize("general.copiedToClipboard"), toast)}
                      >
                        {n}
                      </span>
                    ))}
                  </Typography>
                </Stack>
              ) : null}
            </Stack>
          ) : (
            <Stack direction="row" justifyContent="flex-end" className={prefixClassName("contact-shop-wrapper")}>
              <Link
                href={renderCarrierLink(
                  organization.shopifyStoreData?.customer_email,
                  trackingInfo[0]?.trackingCompany
                )}
                className={prefixClassName("contact-shop")}
                variant="caption1"
                underline="always"
                target="_blank"
                sx={{
                  opacity: "70%",
                  cursor: "pointer",
                  "&:hover": {
                    opacity: "60%",
                  },
                }}
              >
                {typedLocalize("orderHistory.contactShop")}
              </Link>
            </Stack>
          )}
        </React.Fragment>
      ) : null}
      <OrderHistoryShippedTo
        subscription={subscription}
        deliveryMethod={deliveryMethod}
        shippingAddress={deliveryAddress}
      />
      <OrderHistoryShippingMethod deliveryMethodTitle={deliveryMethodTitle} />
    </CardBodySection>
  );
};
